import { Product } from '.';
import { Profile } from './user.models';

export enum CheckoutProvider {
  Vpos = 'vpos',
  PayPal = 'paypal',
}
export enum PurchaseStatus {
  New = 'NEW',
  Finalized = 'FINALIZED',
  Error = 'ERROR',
  Canceled = 'CANCELED',
}

export interface CheckoutResponse {
  redirectTo: string;
}

export interface PdrConfiguration {
  pdr?: {
    cap: string;
    lat: string;
    lng: string;
    tel: string;
    uri: string;
    name: string;
    orari: string;
    civico: string;
    comune: string;
    indice: string;
    pointid: string;
    localita: string;
    toponimo: string;
    categoria: string;
    indirizzo: string;
    provincia: string;
    presso_note: string;
    id_categoria: string;
    pdr_published_status: string;
    chiusura_straordinaria: string;
  };
  pdrId: string;
}

export type RescheduleConfiguration = {
  timeRange: string;
};

export type BaseCartElement<T extends Product> = {
  id: number;
  product: T;
  orderId: number;
  price: number;
  originalPrice: number;
};

export type RescheduleCartElement = BaseCartElement<Product.Appointment> & {
  configuration: RescheduleConfiguration;
};

export type PdrCartElement = BaseCartElement<Product.Pdr> & {
  configuration: PdrConfiguration;
};

export type CartElement = RescheduleCartElement | PdrCartElement;

export type PurchaseItem = CartElement & {
  createdAt: Date;
  modifiedAt: Date;
  purchaseId: number;
  status: PurchaseStatus;
};

export interface Purchase {
  id: number;
  status: PurchaseStatus;
  createdAt: string;
  modifiedAt: string;
  customerId: number;
  billingAddressId: number;
  total: number;
  cartId: number;
  items?: PurchaseItem[];
  refundRequested: boolean;
  billingAddress: Profile;
}

export type PutCartRequest = Omit<
  CartElement,
  'id' | 'price' | 'originalPrice'
>;

export interface NoLoggedFreeRequest {
  body: RescheduleConfiguration;
  id: number;
}

export interface GetCartResponse {
  items: CartElement[];
  total: number;
}

export interface EditCartElementRequest {
  cartElement: Omit<CartElement, 'price' | 'originalPrice'>;
}
